export type TocItem = { id: string; title: string; level: number }

const slugify = (text: string) =>
  text
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9\s-]/g, "")
    .trim()
    .replace(/\s+/g, "-")
    .replace(/-+/g, "-")

export const extractTableOfContents = (html: string): { toc: TocItem[]; htmlWithIds: string } => {
  if (!html) return { toc: [], htmlWithIds: "" }

  const existingIds = new Set<string>()
  const toc: TocItem[] = []
  let index = 0

  const htmlWithIds = html.replace(/<(h[2-5])([^>]*)>([\s\S]*?)<\/\1>/gi, (full, tag, attrs, inner) => {
    // Remove all HTML tags and decode HTML entities
    let text = String(inner)
      .replace(/<[^>]+>/g, "")
      .trim()

    // Decode common HTML entities
    text = text
      .replace(/&nbsp;/g, " ")
      .replace(/&amp;/g, "&")
      .replace(/&lt;/g, "<")
      .replace(/&gt;/g, ">")
      .replace(/&quot;/g, '"')
      .replace(/&#039;/g, "'")
      .replace(/&apos;/g, "'")
      .trim()

    // Skip if text is empty or only contains whitespace/special chars
    if (!text || text === "" || /^[\s\u00A0]*$/.test(text)) {
      return full
    }

    const idMatch = String(attrs).match(/\sid=["']([^"']+)["']/i)
    let id = idMatch?.[1]
    if (!id) {
      const base = slugify(text) || `section-${index}`
      id = base
      while (existingIds.has(id)) id = `${base}-${++index}`
      attrs = `${attrs} id="${id}"`
    }
    existingIds.add(id)

    const level = Number(String(tag).slice(1))
    toc.push({ id, title: text, level })
    return `<${tag}${attrs}>${inner}</${tag}>`
  })

  return { toc, htmlWithIds }
}
